import {APP} from 'jsAssets/constants/app';
import _u from "jsAssets/utils/index";

// initial state
const state = {
    chosenCourseID: null,
    courseSchema: {},
    requestIsSuccess: false
};

// getters
const getters = {
    chosenCourseID: state => state.chosenCourseID,
    courseSchema: state => state.courseSchema,
    requestIsSuccess: state => state.requestIsSuccess,
};

// actions
const actions = {
    createCourse({ commit }, item){
        let params = {
            'handler': 'course',
            'func': 'createCourseOrder',
            'user_name': item.userName,
            'user_email': item.userEmail,
            'user_phone': item.userPhone,
            'course_id': item.courseId,
            'members_count': item.membersCount,
        };
        commit('app/setLoadingData', true, { root: true });
        _u.requestHttp('get',  APP.ajax_endpoint, params, (responseData) => {
           commit('setCourseSchema', responseData.data.data.FormSchema);
           commit('setRequestIsSuccess', responseData.data.data.requestIsSuccess);
           commit('app/setLoadingData', false, { root: true });

        });
    },

    getSchema({ commit }) {
        let params = {
            'handler': 'course',
            'func': 'getFormSchema',
        };
        commit('app/setLoadingData', true, { root: true });
        _u.requestHttp('get',  APP.ajax_endpoint, params, (responseData) => {
            commit('setCourseSchema', responseData.data.data.FormSchema);
            commit('setRequestIsSuccess',false); // получая начальный шаблон курс не может быть уже оформленным
            commit('app/setLoadingData', false, { root: true });
        });
    },
};

// mutations
const mutations = {
    setChosenCourseID (state, chosenCourseID) {
        state.chosenCourseID = chosenCourseID;
    },
    setCourseSchema (state, courseSchema) {
        state.courseSchema = courseSchema;
    },
    setRequestIsSuccess (state, requestIsSuccess) {
        state.requestIsSuccess = requestIsSuccess;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
